// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimelineSidebar_sidebar__SY8vs {
  background: #f9fafb;
  border-right: 1px solid #e2e8f0;
  padding: 0;
  flex: 0 0 240px;
  box-sizing: border-box;
}

/* компенсатор высоты шкалы времени */
.TimelineSidebar_topSpacer__t0A0\\+ {
  height: 26px; /* совпадает с .ticksRowLocal */
  border-bottom: 1px solid #f1f5f9;
  background: #f9fafb;
}

.TimelineSidebar_row__pF9zd {
  display: flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background 0.15s;
  box-sizing: border-box;
}

.TimelineSidebar_row__pF9zd:hover {
  background: #f1f5f9;
}

.TimelineSidebar_active__ZdzVC {
  background: #4a6cf7;
  color: #fff;
}

.TimelineSidebar_active__ZdzVC:hover {
  background: #4a6cf7; /* остаётся как активный фон */
  color: #fff;
  cursor: default; /* опционально, чтобы не мигала рука */
}

.TimelineSidebar_statusDot__V\\+tHF {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
}

.TimelineSidebar_address__jVMVp {
  font-size: 0.85rem;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Routes/modal/timeline/TimelineSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,YAAY,EAAE,+BAA+B;EAC7C,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,8BAA8B;EACnD,WAAW;EACX,eAAe,EAAE,sCAAsC;AACzD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;AACT","sourcesContent":[".sidebar {\r\n  background: #f9fafb;\r\n  border-right: 1px solid #e2e8f0;\r\n  padding: 0;\r\n  flex: 0 0 240px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* компенсатор высоты шкалы времени */\r\n.topSpacer {\r\n  height: 26px; /* совпадает с .ticksRowLocal */\r\n  border-bottom: 1px solid #f1f5f9;\r\n  background: #f9fafb;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 22px;\r\n  padding: 0 8px;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.row:hover {\r\n  background: #f1f5f9;\r\n}\r\n\r\n.active {\r\n  background: #4a6cf7;\r\n  color: #fff;\r\n}\r\n\r\n.active:hover {\r\n  background: #4a6cf7; /* остаётся как активный фон */\r\n  color: #fff;\r\n  cursor: default; /* опционально, чтобы не мигала рука */\r\n}\r\n\r\n.statusDot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  margin-right: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.address {\r\n  font-size: 0.85rem;\r\n  line-height: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  flex: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `TimelineSidebar_sidebar__SY8vs`,
	"topSpacer": `TimelineSidebar_topSpacer__t0A0+`,
	"row": `TimelineSidebar_row__pF9zd`,
	"active": `TimelineSidebar_active__ZdzVC`,
	"statusDot": `TimelineSidebar_statusDot__V+tHF`,
	"address": `TimelineSidebar_address__jVMVp`
};
export default ___CSS_LOADER_EXPORT___;
